import { PayrunSteps } from '../payrun-stepper.types';
export const PayrunStepperTestId = {
  container: 'payrun-stepper',
  SingleStep: (step: PayrunSteps) => `payrun-stepper-step-${step ?? ''}`,
  StepIcon: (step: PayrunSteps) => `payrun-stepper-step-icon-${step ?? ''}`,
};
